class productCard extends HTMLElement {
  constructor () {
    super()
    this.location = window.location
    this.urlParams = new URLSearchParams(this.location.search)
    this.currentPage = this.closest('.grid__item')?.dataset.currentPagination
    this.maintainPosition = true
  }

  connectedCallback () {
    if (!this.maintainPosition) return
    this.addEventListener('click', e => {
      e.preventDefault()
      const isWishlistButton = e.target.localName === 'fostr-wishlist-button'

      if ((e.target.tagName === 'BUTTON' && e.target.name === 'add') || isWishlistButton) return

      this.urlParams.set('page', this.currentPage)
      this.urlParams.set('pid', this.dataset.productId)
      this.currentUrl = `${window.location.pathname}?${this.urlParams}`
      const localRegex = /\/[a-z]{2}-[a-z]{2}\//
      if (!localRegex.test(this.currentUrl)) {
        this.currentUrl = (Shopify.routes.root + this.currentUrl).replace('//', '/')
      }

      history.replaceState(null, '', this.currentUrl)

      let cardLink = this.querySelector('a').href
      if (!localRegex.test(cardLink)) {
        cardLink = this.querySelector('a').href.replace('/products', `${Shopify.routes.root}products`)
      }

      window.location.href = cardLink
    })
  }
}

customElements.define('product-card', productCard)
